var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 533,
    viewBox: "0 0 533 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.499 1.15269e-05C119.549 1.15269e-05 0 119.549 0 266.503C0 413.447 119.549 533 266.499 533C413.446 533 533 413.447 533 266.503C533 119.549 413.446 1.15269e-05 266.499 1.15269e-05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.5 489C143.811 489 44 389.184 44 266.503C44 143.816 143.811 44 266.5 44C389.187 44 489 143.816 489 266.503C489 389.184 389.187 489 266.5 489",
    fill: "#F57A14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.163 421C241.916 421 239.283 418.734 239.283 415.708V191.675H166.876C163.497 191.675 162 188.268 162 186.001V149.298C162 147.021 163.497 144 166.876 144H366.122C369.489 144 371 147.021 371 149.298V186.001C371 188.268 369.489 191.675 366.122 191.675H293.706V415.708C293.706 418.734 291.445 421 288.444 421H244.163Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/Train.fbb6e403.svg";
export { ForwardRef as ReactComponent };